





































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    API_URL
} from "../global";
import {
    pageDataType,
    componentDataType,
    settinglinkItem
} from "../types";

import {
    SET_GLOBAL_ERROR,
    SET_GLOBAL,
    SET_GLOBAL_LOADED,
    SET_SETTING_DATA
} from "../store/mutations.names";
import {
    FETCH_GLOBAL,
    FETCH_SETTING_DATA,
    FETCH_SETTING

} from "../store/actions.names";

import axios from 'axios';
@Component({
    name: "Gmap",
    components: {

    }

})
export default class Gmap extends Vue {
    @Getter("settinglink") public settinglink!: settinglinkItem[];
    @Action(FETCH_SETTING) public[FETCH_SETTING]: any;
    current = 0;
    showMap: boolean = false;
    filter = {
        address: null
    };
    addressdata: any[] = [];

    startLocation: any = {
       lat : 23.7808875, 
      lng : 90.2792371 
    }
    address: string = "Headquarter";
    addressOptions = ["Headquarter", "Local"];
    data () {
  return {
      lat : 23.7808875, 
      lng : 90.2792371 
  }
}
    @Watch("address", {
        immediate: true
    })

    infoOptions: any = {
        pixelOffset: {
            width: 0,
            height: -35
        }
    }
    infoPosition: null = null;
    infoContent: null = null;
    infoOpened: boolean = false;
    infoCurrentKey: null = null;
    selectedAdress: number = -1;
    selectedOption: any = '';
    options: any = [];
    selectedDrinkLabel: any = '';

    getPosition(marker: any) {
        return {
            lat: parseFloat(marker.lat),
            lng: parseFloat(marker.lng)
        }
    }
centerMap(filter: any){
   // console.log('amar nam saddam');
    this.addressdata.map((item: any) => {
        if(filter == item.id){
            (this as any).lat = item.lat;
                    (this as any).lng = item.lng;
        //    const lat = (this as any).item.lat;
        //     const lng =  (this as any).item.lng;
        
        //  console.log((this as any).lat);
        //   console.log((this as any).lng);
        }
        // return {
        //     lat: item.lat,
        //     lng: item.lng,
        // };
    //   console.log(item.lat);
    // console.log(item.lng);
        }); 

//  console.log(filter);
}
    // toggleInfo(marker: any, key: any) {
    //     (this as any).infoPosition = this.getPosition(marker);
    //     (this as any).infoContent = marker.full_name;
    //     if ((this as any).infoCurrentKey == key) {
    //         (this as any).infoOpened = !(this as any).infoOpened;
    //     } else {
    //         (this as any).infoOpened = true;
    //         (this as any).infoCurrentKey = key;
    //     }
    // }

    // selectAddress() {
    //     (this as any).selectedOption = '';
    //     (this as any).options = (this as any).settingdata.address.address;
    //     // (this as any).selectedDrinkLabel = (this as any).drinks[(this as any).selectedDrink].label;
    // }
    handleScroll(event: any) {
        let d: any = document;
        let scrollpos = window.scrollY;
        const elem = d.querySelector('.map-wrapper');
        const counterlist = (window.scrollY + window.innerHeight);
        const isHalfshown = counterlist > elem.offsetTop;
        const countbottom = elem.offsetTop + elem.height;
        const isNotscrolledPast = window.scrollY < countbottom;
        if (isHalfshown) {
            (this as any).showMap = true;
        }

    }
    created() {

        axios.get(`${API_URL}/others/locations/`)
            .then(response => {
                (this as any).addressdata = response.data
            })
            .catch(e => {
                (this as any).errors.push(e)
            })
        window.addEventListener('scroll', this.handleScroll);
    }

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    mounted() {
        this[FETCH_SETTING]();
    }

}
